import { Component } from "@theme/component";

class VideoWindowComponent extends Component {
  requiredRefs = [
    "floatingMini",
    "videoGuide",
    "floatingFullClose",
    "muteBtn",
    "unmuteIcon",
    "muteIcon",
    "floatingFull",
  ];

  /** @type {HTMLElement & { swiper?: any } | null} */
  #videoSwiperComponent = null;

  /** @type {Array<HTMLElement & { swiper?: any }>} */
  #productSwiperComponents = [];

  /** @type {boolean} */
  #swipersInited = false;

  /** @type {NodeListOf<HTMLVideoElement> | HTMLVideoElement[]} */
  #allVideos = [];

  /** @type {HTMLElement[]} */
  #floatingBtns = [];

  /** @type {boolean} */
  #animating = false;

  /** @type {boolean} */
  #isMuted = false;

  /** @type {boolean} */
  #isInit = false;

  /** @type {HTMLVideoElement | null} */
  #firstVideo = null;

  /** @type {NodeListOf<HTMLElement> | null} */
  #videoSlides = null;

  /** @type {HTMLVideoElement | null} */
  #cachedSingleVideo = null;

  get isMobile() {
    return window.innerWidth < 768;
  }

  connectedCallback() {
    super.connectedCallback();
    this.#allVideos = this.querySelectorAll(".floating-full video");
    this.#floatingBtns = Array.from(
      this.querySelectorAll(".floating-full button")
    );
    this.#checkVideoGuide();
    this.#firstVideo = this.querySelector(".swiper-slide:first-child video");
    this.#videoSlides = this.querySelectorAll(
      ".swiper-video-container .swiper-slide"
    );

    // 添加事件监听器
    const floatingMini = /** @type {HTMLElement} */ (this.refs.floatingMini);
    const floatingFullClose = /** @type {HTMLElement} */ (
      this.refs.floatingFullClose
    );
    const muteBtn = /** @type {HTMLElement} */ (this.refs.muteBtn);
    const videoGuide = /** @type {HTMLElement} */ (this.refs.videoGuide);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  #checkVideoGuide() {
    if (!this.isMobile) return;
    const hasShownGuide = sessionStorage.getItem("videoGuideShown");
    const videoGuide = /** @type {HTMLElement} */ (this.refs.videoGuide);
    if (hasShownGuide && videoGuide) {
      videoGuide.style.display = "none";
    } else if (videoGuide) {
      videoGuide.style.display = "flex";
    }
  }

  hideVideoGuide() {
    const videoGuide = /** @type {HTMLElement} */ (this.refs.videoGuide);
    if (!videoGuide) return;
    videoGuide.style.display = "none";
    sessionStorage.setItem("videoGuideShown", "true");
  }

  toggleMute() {
    this.#isMuted = !this.#isMuted;
    this.#allVideos.forEach((video) => {
      video.muted = this.#isMuted;
    });

    const unmuteIcon = /** @type {HTMLElement} */ (this.refs.unmuteIcon);
    const muteIcon = /** @type {HTMLElement} */ (this.refs.muteIcon);

    // 切换图标显示
    if (!this.#isMuted) {
      if (unmuteIcon) unmuteIcon.style.display = "block";
      if (muteIcon) muteIcon.style.display = "none";
    } else {
      if (unmuteIcon) unmuteIcon.style.display = "none";
      if (muteIcon) muteIcon.style.display = "block";
    }
  }

  /**
   * 初始化所有 Swiper 组件
   */
  #initAllSwipers() {
    if (this.#swipersInited) return;

    // 初始化产品 Swiper
    this.#productSwiperComponents = [];
    const productSwiperComponents = this.querySelectorAll(
      ".video-floating__products-container swiper-component"
    );

    productSwiperComponents.forEach((swiperComponentEl, index) => {
      const swiperComponent = /** @type {HTMLElement & { swiper?: any } } */ (swiperComponentEl);
      // 检查该 swiper 容器内是否有产品 slides
      const hasProducts = swiperComponent.querySelector(".swiper-slide") !== null;
      if (hasProducts) {
        // 设置 open 属性以触发初始化
        if (!swiperComponent.hasAttribute("open")) {
          swiperComponent.setAttribute("open", "");
        }

        // 等待 swiper-component 初始化完成
        const checkSwiper = setInterval(() => {
          if (swiperComponent.swiper) {
            this.#productSwiperComponents.push(swiperComponent);
            clearInterval(checkSwiper);
          }
        }, 100);

        // 超时保护
        setTimeout(() => clearInterval(checkSwiper), 5000);
      } else {
        // 如果没有产品，隐藏导航按钮
        const nextButton = this.querySelector(
          `.product-button-next${index + 1}`
        );
        const prevButton = this.querySelector(
          `.product-button-prev${index + 1}`
        );
        if (nextButton) {
          /** @type {HTMLElement} */ (nextButton).style.display = "none";
        }
        if (prevButton) {
          /** @type {HTMLElement} */ (prevButton).style.display = "none";
        }
      }
    });

    // 初始化视频 Swiper
    if (this.#videoSlides && this.#videoSlides.length > 1) {
      const swiperComponent = /** @type {HTMLElement & { swiper?: any } | null} */ (
        this.querySelector(".swiper-video-container")
      );

      if (swiperComponent) {
        // 根据设备类型设置方向
        swiperComponent.setAttribute(
          "data-direction",
          this.isMobile ? "vertical" : "horizontal"
        );

        // 设置 open 属性以触发初始化
        if (!swiperComponent.hasAttribute("open")) {
          swiperComponent.setAttribute("open", "");
        }

        // 等待 swiper-component 初始化完成
        const checkSwiper = setInterval(() => {
          if (swiperComponent.swiper) {
            this.#videoSwiperComponent = swiperComponent;
            // 监听幻灯片切换事件
            swiperComponent.swiper.on("slideChange", (/** @type {any} */ swiper) => {
              this.handleVideoPlayback(swiper);
            });
            clearInterval(checkSwiper);
          }
        }, 100);

        // 超时保护
        setTimeout(() => clearInterval(checkSwiper), 5000);
      }
    } else {
      // 如果只有一个视频，隐藏导航按钮
      const nextButton = this.querySelector(".video-button-next");
      const prevButton = this.querySelector(".video-button-prev");
      if (nextButton) {
        /** @type {HTMLElement} */ (nextButton).style.display = "none";
      }
      if (prevButton) {
        /** @type {HTMLElement} */ (prevButton).style.display = "none";
      }
    }

    this.#swipersInited = true;
  }

  /**
   * @param {MouseEvent} e
   */
  handleOpenModal(e) {
    const target = /** @type {HTMLElement} */ (e.target);
    const rect = target.getBoundingClientRect();
    this.#openModal(rect);
  }

  /**
   * @param {any} swiper
   */
  handleVideoPlayback(swiper) {
    if (!swiper) return;
    const videoElements = Array.from(swiper.slides)
      .map((slide) => slide.querySelector("video"))
      .filter((video) => video);

    videoElements.forEach((video, index) => {
      if (!this.#isInit) {
        video.muted = false;
      }
      if (index === swiper.activeIndex) {
        video.play();
      } else {
        video.pause();
      }
    });
    this.#isInit = true;
  }

  /**
   * @param {DOMRect} fromRect
   */
  #openModal(fromRect) {
    if (this.#animating) return;
    this.#animating = true;

    if (this.isMobile) {
      this.#checkVideoGuide();
    }

    // 初始化 Swipers（仅在第一次打开时）
    this.#initAllSwipers();

    // 手动加载第一个视频（如果还没有加载）
    if (this.#firstVideo && !(/** @type {HTMLVideoElement} */ (this.#firstVideo)).src) {
      const sources = this.#firstVideo.querySelectorAll("source[data-src]");
      sources.forEach((source) => {
        const sourceEl = /** @type {HTMLSourceElement} */ (source);
        const dataSrc = sourceEl.getAttribute("data-src");
        if (dataSrc) {
          sourceEl.src = dataSrc;
        }
        sourceEl.removeAttribute("data-src");
      });
      this.#firstVideo.load();
    }

    const floatingFull = /** @type {HTMLElement} */ (this.refs.floatingFull);
    const floatingFullContentEl = /** @type {HTMLElement} */ (
      floatingFull?.querySelector(".floating-full-content")
    );

    if (floatingFull && floatingFullContentEl) {
      // 1. 先显示模态内容
      floatingFull.style.display = "flex";

      // 2. 复位为未缩放进行精确测量
      floatingFullContentEl.style.transition = "none";
      floatingFullContentEl.style.opacity = "0";
      floatingFullContentEl.style.transform = "none";
      floatingFullContentEl.style.visibility = "hidden";

      // 强制重绘后测量
      floatingFull.style.visibility = "visible";
      floatingFullContentEl.offsetWidth;
      const modalRect = floatingFullContentEl.getBoundingClientRect();
      const centerX = fromRect.left + fromRect.width / 2;
      const centerY = fromRect.top + fromRect.height / 2;
      const originX = centerX - modalRect.left;
      const originY = centerY - modalRect.top;

      // 设置变换原点
      floatingFullContentEl.style.transformOrigin = `${originX}px ${originY}px`;

      // 设置初始缩放并显示
      floatingFullContentEl.style.visibility = "";
      floatingFullContentEl.style.transform = "scale(0.2)";

      // 强制重绘
      floatingFullContentEl.offsetWidth;

      // 动画到 scale(1)
      floatingFullContentEl.style.transition =
        "transform 0.3s ease, opacity 0.2s";
      floatingFull.classList.add("active");

      document.body.setAttribute("scroll-lock", "");

      setTimeout(() => {
        this.#animating = false;
        this.#floatingBtns.forEach((btn) => {
          btn.style.opacity = "1";
        });

        // 模态框完全展开后，触发当前视频播放
        if (this.#videoSwiperComponent?.swiper) {
          this.handleVideoPlayback(this.#videoSwiperComponent.swiper);
        } else {
          // 缓存单个视频元素
          if (!this.#cachedSingleVideo && this.#videoSlides && this.#videoSlides.length > 0) {
            this.#cachedSingleVideo = /** @type {HTMLVideoElement | null} */ (
              this.#videoSlides[0]?.querySelector("video")
            );
          }
          // 播放唯一的视频
          if (this.#cachedSingleVideo) {
            if (!this.#isInit) {
              this.#cachedSingleVideo.muted = false;
              this.#isInit = true;
            }
            this.#cachedSingleVideo.play();
          }
        }
      }, 300);
    }
  }

  closeModal() {
    if (this.#animating) return;
    this.#animating = true;

    const videoGuide = /** @type {HTMLElement} */ (this.refs.videoGuide);
    const floatingFull = /** @type {HTMLElement} */ (this.refs.floatingFull);

    if (videoGuide && floatingFull) {
      videoGuide.style.display = "none";
      floatingFull.classList.remove("active");
      document.body.removeAttribute("scroll-lock");

      this.#floatingBtns.forEach((btn) => {
        btn.style.opacity = "0";
      });

      setTimeout(() => {
        this.#animating = false;
        floatingFull.style.display = "none";
        // 关闭时暂停所有视频
        this.#allVideos.forEach((video) => {
          video.pause();
        });
      }, 300);
    }
  }
}

if (!customElements.get("video-window-component")) {
  customElements.define("video-window-component", VideoWindowComponent);
}
